"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConductionMethod = void 0;
var ConductionMethod;
(function (ConductionMethod) {
    ConductionMethod["Default"] = "";
    ConductionMethod["OwnerAccount"] = "owner-account";
})(ConductionMethod = exports.ConductionMethod || (exports.ConductionMethod = {}));
//# sourceMappingURL=conduction-method.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-experiments/dist/src/conduction-method.js
// module id = 477
// module chunks = 0